import React, { useState } from 'react';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import PageSubTitle from '../Components/Layout/PageSubTitle';
import MenuItemList from '../data/menu-list.json';
import MenuItems from '../Components/Sections/MenuItems';
import BlogPost from '../Components/Sections/BlogPost';

export default function FoodMenu() {
  const [MenuItemListData] = useState(MenuItemList);
  return (
    <>
      <PageSubTitle pagename="Our Menu" />
      <section className='section'>
        <Container>
          <Row>
            <Col md={12}>
              <Tab.Container id="pills-tab" defaultActiveKey="breakfast">
                <Row className="mb-3 food-menu-tab-sticky">
                  <Col sm={12}>
                    <div className='food-menu-tab'>
                      <Nav variant="pills" className='justify-content-center'>
                        <Nav.Item>
                          <Nav.Link eventKey="breakfast">Breakfast</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="lunch">Lunch</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="dinner">Dinner</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="dessert">Dessert</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link eventKey="drink">Drink</Nav.Link>
                        </Nav.Item>
                      </Nav>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <Tab.Content>
                      <Tab.Pane eventKey="breakfast">
                        <MenuItems menuData={MenuItemListData.BreakfastMenuItemData} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="lunch">
                        <MenuItems menuData={MenuItemListData.LunchMenuItemData} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="dinner">
                        <MenuItems menuData={MenuItemListData.DinnerMenuItemData} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="dessert">
                        <MenuItems menuData={MenuItemListData.DessertMenuItemData} />
                      </Tab.Pane>
                      <Tab.Pane eventKey="drink">
                        <MenuItems menuData={MenuItemListData.DrinkMenuItemData} />
                      </Tab.Pane>
                    </Tab.Content>
                  </Col>
                  <Col md={12} className='text-center mt-4'>
                    <i className="ri-loop-right-line text-dark fs-26 icon-spin"></i>
                  </Col>
                </Row>
              </Tab.Container>
            </Col>
          </Row>
        </Container>
      </section>

      <BlogPost />
    </>
  )
}
